import { gql } from '@grandvisionhq/graphql';
import { cartDetails } from '../fragments/cart-details.js';
import { cartValidationErrors } from '../fragments/cart-validation-errors.js';

const REPLACE_CONTACT_LENS_BUNDLE_BENELUX_CART_LINE_ITEM = gql`
  mutation ReplaceContactLensBundleBeneluxCartLineItem(
    $cartInput: ReplaceCartContactLensBundleBeneluxLineItemInput!
  ) {
    replaceContactLensBundleBeneluxCartLineItem(cartInput: $cartInput) {
      cart {
        ...CartDetailsFragment
      }
      validationErrors {
        ...CartValidationErrorsFragment
      }
      success
    }
  }
  ${cartDetails}
  ${cartValidationErrors}
`;

export { REPLACE_CONTACT_LENS_BUNDLE_BENELUX_CART_LINE_ITEM };
//# sourceMappingURL=replace-line-item-contact-lenses-bundle-benelux.js.map
